[
  {
    "afterLevel": 1,
    "readings": [
      {
        "grapheme": "岸",
        "pinyin": "an4"
      },
      {
        "grapheme": "干",
        "pinyin": "gan4"
      },
      {
        "grapheme": "干",
        "pinyin": "gan1"
      },
      {
        "grapheme": "力",
        "pinyin": "li4"
      },
      {
        "grapheme": "一",
        "pinyin": "yi1"
      },
      {
        "grapheme": "二",
        "pinyin": "er4"
      },
      {
        "grapheme": "三",
        "pinyin": "san1"
      },
      {
        "grapheme": "山",
        "pinyin": "shan1"
      }
    ]
  },
  {
    "afterLevel": 2,
    "readings": [
      {
        "grapheme": "历",
        "pinyin": "li4"
      },
      {
        "grapheme": "四",
        "pinyin": "si4"
      },
      {
        "grapheme": "刺",
        "pinyin": "ci4"
      },
      {
        "grapheme": "自",
        "pinyin": "zi4"
      },
      {
        "grapheme": "士",
        "pinyin": "shi4"
      },
      {
        "grapheme": "赤",
        "pinyin": "chi4"
      },
      {
        "grapheme": "至",
        "pinyin": "zhi4"
      },
      {
        "grapheme": "日",
        "pinyin": "ri4"
      }
    ]
  },
  {
    "afterLevel": 3,
    "readings": [
      {
        "grapheme": "个",
        "pinyin": "ge4"
      },
      {
        "grapheme": "车",
        "pinyin": "che1"
      },
      {
        "grapheme": "这",
        "pinyin": "zhe4"
      },
      {
        "grapheme": "乐",
        "pinyin": "le4"
      },
      {
        "grapheme": "了",
        "pinyin": "le0"
      },
      {
        "grapheme": "子",
        "pinyin": "zi0"
      }
    ],
    "words": [
      {
        "definition": "a person's height; stature",
        "pinyin": "ge4 zi0",
        "word": "个子"
      },
      {
        "definition": "this; this one",
        "pinyin": "zhe4 ge4",
        "word": "这个"
      }
    ]
  },
  {
    "afterLevel": 4,
    "readings": [
      {
        "grapheme": "肮",
        "pinyin": "ang1"
      },
      {
        "grapheme": "亢",
        "pinyin": "kang4"
      },
      {
        "grapheme": "脏",
        "pinyin": "zang1"
      },
      {
        "grapheme": "昌",
        "pinyin": "chang1"
      },
      {
        "grapheme": "专",
        "pinyin": "zhuan1"
      },
      {
        "grapheme": "万",
        "pinyin": "wan4"
      },
      {
        "grapheme": "庄",
        "pinyin": "zhuang1"
      },
      {
        "grapheme": "旺",
        "pinyin": "wang4"
      },
      {
        "grapheme": "央",
        "pinyin": "yang1"
      },
      {
        "grapheme": "辆",
        "pinyin": "liang4"
      }
    ]
  },
  {
    "afterLevel": 5,
    "readings": [
      {
        "grapheme": "长",
        "pinyin": "chang2"
      },
      {
        "grapheme": "唱",
        "pinyin": "chang4"
      },
      {
        "grapheme": "肪",
        "pinyin": "fang2"
      },
      {
        "grapheme": "方",
        "pinyin": "fang1"
      },
      {
        "grapheme": "十",
        "pinyin": "shi2"
      },
      {
        "grapheme": "王",
        "pinyin": "wang2"
      },
      {
        "grapheme": "望",
        "pinyin": "wang4"
      },
      {
        "grapheme": "盲",
        "pinyin": "mang2"
      },
      {
        "grapheme": "皇",
        "pinyin": "huang2"
      }
    ]
  },
  {
    "afterLevel": 6,
    "readings": [
      {
        "grapheme": "人",
        "pinyin": "ren2"
      },
      {
        "grapheme": "申",
        "pinyin": "shen1"
      },
      {
        "grapheme": "升",
        "pinyin": "sheng1"
      },
      {
        "grapheme": "坑",
        "pinyin": "keng1"
      },
      {
        "grapheme": "更",
        "pinyin": "geng4"
      },
      {
        "grapheme": "工",
        "pinyin": "gong1"
      },
      {
        "grapheme": "东",
        "pinyin": "dong1"
      },
      {
        "grapheme": "弄",
        "pinyin": "nong4"
      },
      {
        "grapheme": "同",
        "pinyin": "tong2"
      },
      {
        "grapheme": "中",
        "pinyin": "zhong1"
      }
    ]
  },
  {
    "afterLevel": 7,
    "readings": [
      {
        "grapheme": "兜",
        "pinyin": "dou1"
      },
      {
        "grapheme": "丢",
        "pinyin": "diu1"
      },
      {
        "grapheme": "幽",
        "pinyin": "you1"
      },
      {
        "grapheme": "有",
        "pinyin": "you3"
      },
      {
        "grapheme": "尤",
        "pinyin": "you2"
      },
      {
        "grapheme": "右",
        "pinyin": "you4"
      },
      {
        "grapheme": "六",
        "pinyin": "liu4"
      }
    ]
  },
  {
    "afterLevel": 8,
    "readings": [
      {
        "grapheme": "果",
        "pinyin": "guo3"
      },
      {
        "grapheme": "国",
        "pinyin": "guo2"
      },
      {
        "grapheme": "我",
        "pinyin": "wo3"
      },
      {
        "grapheme": "握",
        "pinyin": "wo4"
      },
      {
        "grapheme": "抹",
        "pinyin": "mo3"
      },
      {
        "grapheme": "末",
        "pinyin": "mo4"
      },
      {
        "grapheme": "玉",
        "pinyin": "yu4"
      },
      {
        "grapheme": "于",
        "pinyin": "yu2"
      },
      {
        "grapheme": "羽",
        "pinyin": "yu3"
      },
      {
        "grapheme": "努",
        "pinyin": "nu3"
      },
      {
        "grapheme": "女",
        "pinyin": "nv3"
      },
      {
        "grapheme": "疟",
        "pinyin": "nve4"
      },
      {
        "grapheme": "录",
        "pinyin": "lu4"
      },
      {
        "grapheme": "率",
        "pinyin": "lv4"
      },
      {
        "grapheme": "掠",
        "pinyin": "lve4"
      }
    ],
    "words": []
  }
]
